import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';

export enum MnpEventStatusEnum {
  Unknown = 'Unknown',
  Theft = 'Theft',
  NotTheft = 'NotTheft',
  OperationalIssue = 'OperationalIssue',
}
@Injectable({
  providedIn: 'root',
})
export class MovementNoPurchaseService {
  api2Host = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);

  updateStatus(id: string, newStatus: MnpEventStatusEnum) {
    const requestUrl = `${this.api2Host}/MovementNoPurchase/UpdateStatus/${id}`;
    const data = { status: newStatus };
    return this.httpClient.post(requestUrl, data);
  }

  updateComment(id: string, newComment: string) {
    const requestUrl = `${this.api2Host}/MovementNoPurchase/UpdateComments/${id}`;
    const data = { comments: newComment };
    return this.httpClient.post(requestUrl, data);
  }
}
